import { Chip } from '@mui/material';
import React from 'react';
import { headingFontBold, vars } from '../../../Theme';
import { FormdesignersModeTypes } from '@eplass/formdesigner/domain/mode.types';
import { useTranslation } from 'react-i18next';

/**
 * Chip Component that displays the mode of the Document Details Dialog.
 */
export default ({ type, docTypeKey }: IDocumentDetailsModeProps) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'docDetailsView' });

    return (
        <Chip
            label={t(docTypeKey ? 'create' : type?.toLowerCase())}
            sx={{
                backgroundColor:
                    type === FormdesignersModeTypes.View ? vars.infoBlue : vars.brandGreen,
                color: vars.white,
                ...headingFontBold,
                fontSize: '14px',
                height: '20px',
            }}
        />
    );
};

/**
 * Interface that describes DocumentDetailsMode's props.
 */
interface IDocumentDetailsModeProps {
    /** Mode of the Document Details Dialog. */
    type: FormdesignersModeTypes;

    /** Document's type key for template creation. */
    docTypeKey: string;
}
